// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_it-0";
export var actionModalContentContainer = "_it-1";
export var createTagButton = "_it-2";
export var footerContainer = "_it-7";
export var fullWidthDivider = "_it-3";
export var hasCreateTagButton = "_it-4";
export var noCreateTagButton = "_it-5";
export var tagsContainer = "_it-6";
export var tagsModalContentContainer = "_it-8";